<template>
  <div class="accordion-item">
    <h2 class="accordion-header" :id="'heading' + options.selectors.id">
      <button
        class="accordion-button bg-light"
        :id="options.selectors.id + '-Btn'"
        type="button"
        data-bs-toggle="collapse"
        :data-bs-target="'#' + options.selectors.id + 'collapse'"
        aria-expanded="false"
        :aria-controls="options.selectors.id + 'collapse'"
      >
        {{ "id=" + options.selectors.id + "-Btn" }}
      </button>
    </h2>
    <div
      :id="options.selectors.id + 'collapse'"
      class="accordion-collapse bg-light collapse"
      :class="{ show: options.selectors.class }"
      :aria-labelledby="'heading' + options.selectors.id"
    >
      <div class="accordion-body">
        <div class="col pt-4">
          <div>
            <select
              class="form-select"
              :id="options.selectors.id + 'Select'"
              v-model="selectedValue"
              @change="emitValue(selectedValue)"
            >
              <option value="" :id="options.selectors.id + 'All'">
                Alle opties
              </option>
              <template
                v-for="(value, key) in options.properties.values"
                :key="key"
              >
                <option :value="value">
                  {{ value }} {{ options.properties.unit }}
                </option>
              </template>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterOptions",
  emits: ["selected"],
  props: {
    options: {
      properties: Object,
      selectors: {
        class: Object,
        id: Object,
      },
    },
  },
  data() {
    return {
      selectedValue: "",
    };
  },
  methods: {
    emitValue(value) {
      const key = this.options.properties.key;
      this.$emit("selected", { key, value });
    },
  },
  created() {},
  mounted() {},
  beforeUpdate() {
    if (
      !this.options.properties.values.includes(this.selectedValue) &&
      this.selectedValue !== ""
    ) {
      this.selectedValue = "";
      this.emitValue(this.selectedValue);
    }
  },
};
</script>
